export const OnboardingParams = {
  journey: {
    key: "journey",
    value: "onboarding",
  },
};
